module.exports = __webpack_public_path__ + "img/no-image.d30b81ef.png";